var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVoiceMessageRed = function SvgVoiceMessageRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "keyboard_voice_black_24dp")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-12-Pro",
    transform: "translate(-318.000000, -794.000000)",
    fill: "#FF5C5C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keyboard_voice_black_24dp",
    transform: "translate(318.000000, 794.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21052632,15.7894737 C11.3947368,15.7894737 13.1447368,14.0263158 13.1447368,11.8421053 L13.1578947,3.94736842 C13.1578947,1.76315789 11.3947368,0 9.21052632,0 C7.02631579,0 5.26315789,1.76315789 5.26315789,3.94736842 L5.26315789,11.8421053 C5.26315789,14.0263158 7.02631579,15.7894737 9.21052632,15.7894737 Z M17.2105263,11.8421053 C16.6578947,11.8421053 16.1973684,12.2368421 16.1184211,12.7763158 C15.6315789,16.2105263 12.5394737,18.5526316 9.21052632,18.5526316 C5.88157895,18.5526316 2.78947368,16.2236842 2.30263158,12.7763158 C2.22368421,12.2368421 1.75,11.8421053 1.21052632,11.8421053 C0.526315789,11.8421053 3.88578059e-16,12.4473684 0.0921052632,13.1184211 C0.697368421,17.0263158 3.98684211,20.0921053 7.89473684,20.6842105 L7.89473684,23.6842105 C7.89473684,24.4078947 8.48684211,25 9.21052632,25 C9.93421053,25 10.5263158,24.4078947 10.5263158,23.6842105 L10.5263158,20.6842105 C14.4210526,20.1184211 17.7236842,17.0263158 18.3289474,13.1184211 C18.4210526,12.4473684 17.8947368,11.8421053 17.2105263,11.8421053 Z",
    id: "Shape"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVoiceMessageRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/voice_message_red.c092a063.svg";
export { ForwardRef as ReactComponent };